module.exports = __webpack_public_path__ + "static/media/accommodation.6884c360.jpeg";